export const reviews: Array<[string, string, string, string, string]> = [
  [
    'MG',
    'María G.',
    'Docente de Automatización Industrial · Buenos Aires',
    'En una tarde tenía más material sobre automatización industrial contextualizado en Argentina que en toda mi carrera profesional. Ahora mis alumnos y colegas me preguntan sobre sensores, PLC, programación Ladder, electroneumática, motores, variadores, redes industriales y HMI, y tengo respuesta fundamentada para todo. El impacto es visible desde la primera semana.',
    'bg-deep',
  ],
  [
    'RT',
    'Rodrigo T.',
    'Instructor de Talleres Técnicos · Santa Cruz',
    'Mis estudiantes por primera vez entendieron la diferencia entre un sensor inductivo y uno capacitivo, y analizaron casos reales de procesos automatizados en Argentina con normativas de seguridad vigentes. El nivel de participación en las clases se multiplicó y empezaron a ver la automatización como aplicación práctica real, no como teoría abstracta.',
    'bg-petrol',
  ],
  [
    'SP',
    'Sandra P.',
    'Coordinadora de Técnicos en Automatización · Córdoba',
    'Las simulaciones de programación PLC con las plantillas del MEGAPACK son exactamente lo que necesitaba: ejercicios reales de Ladder, automatismos de empresas argentinas, normas de seguridad vigentes, casos de máquinas automatizadas, estrategias de integración PLC-HMI aplicables. Cambió la forma en que planifico todo el año.',
    'bg-steel',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'FM',
    'Federico M.',
    'Buenos Aires · Megapack Automatización Industrial',
    'Con el MEGAPACK, en una tarde tenía el marco conceptual completo para explicar por qué los sistemas se automatizan, cómo funcionan los lazos de control, qué es un PLC y por qué es fundamental para la industria moderna. Mis alumnos empezaron a ver la automatización como tecnología aplicada real. Porque lo es.',
  ],
  [
    'RV',
    'Rosa V.',
    'Neuquén · Megapack Automatización Industrial',
    'Cuando explicás que la automatización no es solo programar máquinas, sino integrar sensores, actuadores, PLCs, redes y supervisión en un sistema coherente, que Argentina tiene empresas que dependen de estos sistemas, que la competencia global requiere esta precisión, empieza un debate sobre industria 4.0 y futuro laboral que ninguna otra asignatura genera con esa profundidad.',
  ],
  [
    'GN',
    'Gabriela N.',
    'Santa Cruz · Megapack Automatización Industrial',
    'Cuando mis alumnos descubren que Argentina tiene fábricas con sistemas de automatización de punta, que existen técnicos especializados cuya labor es mantener y mejorar estos sistemas, que la programación de un PLC puede aumentar la productividad de una empresa, que ser un técnico en automatización es una profesión con futuro, empieza una conversación sobre oportunidades laborales reales que ningún libro de texto puede provocar.',
  ],
  [
    'AS',
    'Alejandro S.',
    'Río Negro · Megapack Automatización Industrial',
    'Cerré mi planificación anual de Automatización Industrial en dos horas. Antes me llevaba semanas. Ahora tengo todo el año organizado con contenidos actualizados, 150 proyectos para elegir y adaptar, 100 ejercicios prácticos listos, 155 formularios y plantillas, diagramas para cada tema y evaluación integrada.',
  ],
  [
    'SM',
    'Sofía M.',
    'Mendoza · Megapack Automatización Industrial',
    'Cuando les digo a mis alumnos que el técnico en automatización que trabaja en una PyME de La Rioja está haciendo lo mismo que los ingenieros en automatización de las grandes corporaciones: detectando oportunidades de automatización, programando PLCs, integrando sistemas, mejorando procesos, aumentando eficiencia y siendo fundamental para la competitividad de la empresa, les estoy enseñando lo que significa ser un profesional técnico demandado en el mundo real.',
  ],
];
